import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useTitle = (title) => {
  const location = useLocation();

  useEffect(() => {
    document.title = `${title} | Mindful Breaks Yoga `;
  }, [location, title]); // Nu wordt de titel geüpdatet wanneer de locatie verandert.
};

export default useTitle;